import { definePreset } from '@primeuix/themes';
import Aura from '@primeng/themes/aura';

/**
 * Binds PrimeNG / Aura semantic primary palette to tenant CSS variables (src/styles/tenant.css).
 * Without this, Aura uses its default emerald scale — not tenant :root colors.
 *
 * The `formField` block keeps PrimeNG inputs visually identical to the native
 * `<input>` / `<select>` / `<textarea>` defaults declared in `src/styles.css`.
 * Change one and update the other.
 */
export const managementPrimePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: 'var(--color-primary-50)',
      100: 'var(--color-primary-100)',
      200: 'var(--color-primary-200)',
      300: 'var(--color-primary-300)',
      400: 'var(--color-primary-400)',
      500: 'var(--color-primary-500)',
      600: 'var(--color-primary-600)',
      700: 'var(--color-primary-700)',
      800: 'var(--color-primary-800)',
      900: 'var(--color-primary-900)',
      950: 'var(--color-primary-950)',
    },
    formField: {
      paddingX: '0.75rem',
      paddingY: '0.5rem',
      borderRadius: '0.5rem',
      sm: {
        fontSize: '0.8125rem',
        paddingX: '0.625rem',
        paddingY: '0.375rem',
      },
      lg: {
        fontSize: '1rem',
        paddingX: '0.875rem',
        paddingY: '0.625rem',
      },
    },
  },
});
